import { render, staticRenderFns } from "./form-maintenance-roleMenuManage.vue?vue&type=template&id=5e72ebb5&scoped=true&"
import script from "./form-maintenance-roleMenuManage.vue?vue&type=script&lang=js&"
export * from "./form-maintenance-roleMenuManage.vue?vue&type=script&lang=js&"
import style0 from "./form-maintenance-roleMenuManage.vue?vue&type=style&index=0&id=5e72ebb5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e72ebb5",
  null
  
)

export default component.exports